import type libBootstrap from 'bootstrap';
import type libJquery from 'jquery';

import type { languageManager as exUtilsLanguage } from '../utils/language';

import exLanguage from '../language';

import { getBootstrap, hasBootstrap, setBootstrap } from './bootstrap';
import { getJquery, hasJquery, setJquery } from './jquery';

// ----------------------------------------------------------------------------

function setLanguage(ex: exUtilsLanguage): void {
    exLanguage.set(ex);
}

function setLocale(locale: string): void {
    exLanguage.setLocale(locale);
}

// ----------------------------------------------------------------------------

// External
const external = {
    // jQuery
    hasJquery,
    set jquery(ex: typeof libJquery) {
        setJquery(ex);
    },
    get jquery(): typeof libJquery {
        return getJquery();
    },

    // Bootstrap
    hasBootstrap,
    set bootstrap(ex: typeof libBootstrap) {
        setBootstrap(ex);
    },
    get bootstrap(): typeof libBootstrap {
        return getBootstrap();
    },

    // Language
    setLanguage,
    setLocale,
    set language(ex: exUtilsLanguage) {
        setLanguage(ex);
    },
    set locale(locale: string) {
        setLocale(locale);
    },
};

// ----------------------------------------------------------------------------

export { setLanguage, setLocale };
export default external;
